import { SITE_URL } from '@/constants';

interface ArticleSeoFaq {
  question: string;
  answer: string;
}

interface ArticleSeoProps {
  title: string;
  description: string;
  path: string;
  breadcrumbName: string;
  faqs?: ArticleSeoFaq[];
  datePublished?: string;
  dateModified?: string;
}

export default function ArticleSeo({
  title,
  description,
  path,
  breadcrumbName,
  faqs,
  datePublished = '2026-06-21',
  dateModified = '2026-06-21',
}: ArticleSeoProps) {
  const siteUrl = typeof __SITE_URL__ !== 'undefined' ? __SITE_URL__ : SITE_URL;

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Article',
            headline: title,
            description,
            author: { '@type': 'Organization', name: 'Superbuy Spreadsheet' },
            datePublished,
            dateModified,
            publisher: { '@type': 'Organization', name: 'Superbuy Spreadsheet', url: siteUrl },
            mainEntityOfPage: { '@type': 'WebPage', '@id': siteUrl + path },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: [
              { '@type': 'ListItem', position: 1, name: 'Home', item: siteUrl + '/' },
              { '@type': 'ListItem', position: 2, name: breadcrumbName, item: siteUrl + path },
            ],
          }),
        }}
      />
      {faqs && faqs.length > 0 && (
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              '@context': 'https://schema.org',
              '@type': 'FAQPage',
              mainEntity: faqs.map((f) => ({
                '@type': 'Question',
                name: f.question,
                acceptedAnswer: { '@type': 'Answer', text: f.answer },
              })),
            }),
          }}
        />
      )}
    </>
  );
}